export default Object.freeze({
    ACHAT: "ACHAT",
    ADMINITRATION_DES_VENTES: "ADMINITRATION DES VENTES",
    COMMERCIAL: "COMMERCIAL",
    COMMERCIAL_ITINERANT: "COMMERCIAL ITINERANT",
    COMMERCIAL_SEDENTAIRE: "COMMERCIAL SEDENTAIRE",
    COMPTABILITE: "COMPTABILITE",
    DIRECTION: "DIRECTION",
    RESPONSABLE_PRODUCTION: "RESPONSABLE PRODUCTION",
    RESPONSABLE_QUALITE: "RESPONSABLE QUALITE",
});
